import React from 'react'
import '../styles/footer.css'
import SocialMediaBar from '../components/socials/SocialMediaBar'

const Footer = () => {
  return (
    <footer className='footer-container'>
      <SocialMediaBar />
    </footer>
  )
}

export default Footer
